import useAutoExpandTextarea from '../hooks/useAutoExpandTextarea.js';
import styles from './AutoExpandTextarea.module.css';

const AutoExpandTextarea = ({
  value,
  onChange,
  onKeyDown,
  onPointerDown,
  placeholder = '',
  autoFocus = false,
  setCursorToEnd = false,
  style = {},
  className = '',
  ...props
}) => {
  const textareaRef = useAutoExpandTextarea(value, setCursorToEnd);

  const combinedClassName = `${styles.textarea} ${className}`.trim();

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onPointerDown={onPointerDown}
      placeholder={placeholder}
      autoFocus={autoFocus}
      rows={1}
      className={combinedClassName}
      style={style}
      {...props}
    />
  );
};

export default AutoExpandTextarea;
